import { Dispatch } from 'redux';
import { childActionType, ChildrenType } from './Types';
import { ApiEndpoints, ActionHandler } from 'Utils';

export const GetAllKids = () => (dispatch: Dispatch) => {
	return ActionHandler(
		{ url: ApiEndpoints.getAllKids, method: 'GET', dispatch },
		res => {
			const { data } = res.data;
			dispatch({ type: ChildrenType.LOAD_ALL_KIDS, payload: { data } });
		},
		error => {
			dispatch({ type: ChildrenType.LOADING_KIDS_FAIL, payload: { errors: error } });
		},
	);
};

export const addKid =
	(fullName: string, dateOfBirths: string, gestation: string, gender: string) => (dispatch: Dispatch) => {
		const dateOfBirth = new Date(dateOfBirths);

		const gestationStatus = gestation != 'Term' ? 'preterm' : 'term';
		const genderStatus = gender != 'BOY' ? 'FEMALE' : 'MALE';
		const data = JSON.stringify({ fullName, dateOfBirth, status: gestationStatus, gender: genderStatus });

		return ActionHandler(
			{ url: ApiEndpoints.addKid, method: 'POST', dispatch, data },
			res => {
				const { data } = res.data;
				dispatch({ type: ChildrenType.ADD_KID, payload: { data } });
			},
			error => {
				dispatch({ type: ChildrenType.LOADING_KIDS_FAIL, payload: { errors: error } });
			},
		);
	};
export const removeOneKid = (id: number) => (dispatch: Dispatch) => {
	return ActionHandler(
		{ url: `${ApiEndpoints.removeKid}/${id}`, method: 'PUT', dispatch },
		res => {
			const { data } = res.data;
			dispatch({ type: ChildrenType.REMOVE_KID });
		},
		error => {
			dispatch({ type: ChildrenType.LOADING_KIDS_FAIL, payload: { errors: error } });
		},
	);
};

export const updateKids = (kids: any) => (dispatch: Dispatch) => {
	const data = JSON.stringify(kids);
	return ActionHandler(
		{ url: `${ApiEndpoints.updateKid}/`, method: 'PUT', dispatch, data },
		res => {
			const { data } = res.data;
			dispatch({ type: ChildrenType.UPDATE_KIDS });
		},
		error => {
			dispatch({ type: ChildrenType.LOADING_KIDS_FAIL, payload: { errors: error } });
		},
	);
};

export const lookupKids = (childId: string) => (dispatch: Dispatch) => {
	return ActionHandler(
		{ url: `${ApiEndpoints.lookupKid}/${childId}`, method: 'GET', dispatch },
		res => {
			const { data } = res.data;
			// eslint-disable-next-line no-console
			console.log(data);
			dispatch({ type: ChildrenType.LOOKUP_KID, payload: { data } });
		},
		error => {
			dispatch({ type: ChildrenType.LOADING_KIDS_FAIL, payload: { errors: error } });
		},
	);
};

export const loadAllToyInstances = (childId: string) => (dispatch: Dispatch) => {
	return ActionHandler(
		{ url: `${ApiEndpoints.userToys}/${childId}/`, method: 'GET', dispatch },
		res => {
			const { data } = res.data;
			// eslint-disable-next-line no-console
			console.log(data);
			dispatch({ type: ChildrenType.TOY_INSTANCES, payload: { data } });
		},
		error => {
			dispatch({ type: ChildrenType.LOADING_KIDS_FAIL, payload: { errors: error } });
		},
	);
};

export const ShipToyAction = (toyId: string) => (dispatch: Dispatch) => {
	return ActionHandler(
		{ url: `${ApiEndpoints.ship}/${toyId}/`, method: 'PATCH', dispatch },
		res => {
			const { data } = res.data;
			// eslint-disable-next-line no-console
			console.log(data);
			// dispatch({ type: ChildrenType.TOY_INSTANCES, payload: { data } });
		},
		error => {
			dispatch({ type: ChildrenType.LOADING_KIDS_FAIL, payload: { errors: error } });
		},
	);
};

export const nextBoxAction = (childId: string) => (dispatch: Dispatch) => {
	return ActionHandler(
		{ url: `${ApiEndpoints.nextToy}/${childId}/`, method: 'GET', dispatch },
		res => {
			const { data } = res.data;
			// eslint-disable-next-line no-console
			console.log(data);
			// dispatch({ type: ChildrenType.NEXT_BOX });
		},
		error => {
			dispatch({ type: ChildrenType.LOADING_KIDS_FAIL, payload: { errors: error } });
		},
	);
};

export const changeExpiryAction = (data: any) => (dispatch: Dispatch) => {
	return ActionHandler(
		{ url: `${ApiEndpoints.changeDate}/${data?.subId}/`, method: 'PATCH', data, dispatch },
		res => {
			const { data } = res.data;
			// eslint-disable-next-line no-console

			// dispatch({ type: ChildrenType.NEXT_BOX });
		},
		error => {
			dispatch({ type: ChildrenType.LOADING_KIDS_FAIL, payload: { errors: error } });
		},
	);
};

export const loadKidAddress = (id: any) => (dispatch: Dispatch) => {
	return ActionHandler(
		{ url: `${ApiEndpoints.kidAddress}/${id}/`, method: 'GET', dispatch },
		res => {
			const { data } = res.data;
			// eslint-disable-next-line no-console
			console.log(data);
			dispatch({ type: ChildrenType.LOAD_ADDRESS_KID, payload: { data } });
		},
		error => {
			dispatch({ type: ChildrenType.LOADING_KIDS_FAIL, payload: { errors: error } });
		},
	);
};
